import type { FaireProductEntity } from "../../entity_types/product";

export const p_fe4ecwvenu: FaireProductEntity = {
  token: "p_fe4ecwvenu",
  type: "product",
  name: "10\" x 10\" Folding Light Box with 12 Color Backdrops",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/58e06ff772dd075b1b65faa8471a87ebc24be6ee5791cc8ce8ada8c4b58427a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd377bd62d7dd01692dfe1947deca2b18fd6521af7ca9febaf6dcfe18ed2c37d.jpeg",
    "https://cdn.faire.com/fastly/fdfbad4ec166dd8f4590dd706a5fc2c66d0acb8e17272da5b06bea11e725aad5.jpeg",
    "https://cdn.faire.com/fastly/b4f60107074e8348772f512c6d89c1304f96ded2ce0db571a72d3f636591b802.jpeg",
    "https://cdn.faire.com/fastly/1571610117c90ef95230e85e77bec6c4d8624846291ee8293c8ee6676be7dcc6.jpeg",
    "https://cdn.faire.com/fastly/9b6efaeab30816098dcd19f4beb82a1ab597fed933e53b605c6674d87b9aa02e.jpeg",
    "https://cdn.faire.com/fastly/88afefbcbcdac9b0fc66160019d80500237c399a89fae3714d6f226fd3c7119a.jpeg",
    "https://cdn.faire.com/fastly/a2ea5559b1c15cb687b13d2de00e418cd4f8a862cf48fa9c176adb35f9eb5907.jpeg",
    "https://cdn.faire.com/fastly/77fccf55d6f7f92a5c6dc0e868152b07eadc0083ebbc3275b8ba36da0ac33bfb.jpeg",
    "https://cdn.faire.com/fastly/d3cc3055f8f59bf803bdce5ede69be5a27d25e1c4c73a504e09c8f2df270c7cd.jpeg"
  ],
  priceDollars: 19.99,
  description: "Take clean, professional-looking product photos with this compact 10\" x 10\" folding light box. The enclosed design gives an evenly lit area that helps reduce shadows and show product detail.\n\n- Size: 10\" x 10\"\n- Includes 12 interchangeable color backdrops\n- Folding design for easy setup, transport and storage\n\nA good fit for photographing jewelry, accessories, collectibles, small gifts and other compact merchandise for online listings, catalogs and social posts.",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:05.887Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
